import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  wrapperDays: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
    gridGap: theme.spacing(1.25),
    alignItems: "stretch",
    marginTop: theme.spacing(2.5),
  },
}));

export default useStyles;
